export const scooterAction = {
  SET_SCOOTER_STATE: "SET_SCOOTER_STATE",
  FETCH_SCOOTER_DATA: "FETCH_SCOOTER_DATA",
  ADD_ACCESSORY_TO_CART: "ADD_ACCESSORY_TO_CART",
  REMOVE_ACCESSORY_FROM_CART: "REMOVE_ACCESSORY_FROM_CART",
  RECOVERY_TEMPORARY_STORAGE: "RECOVERY_TEMPORARY_STORAGE",
  SET_VIN: "SET_VIN",
  SET_QUERY_LOCAL_SUBSIDY_PAYLOAD: "SET_QUERY_LOCAL_SUBSIDY_PAYLOAD",
  SET_COLOR_CODE: "SET_COLOR_CODE",

  setScooterState: (data) => ({
    type: scooterAction.SET_SCOOTER_STATE,
    payload: data,
  }),

  fetchScooterData: (name, method, url, postData, loading) => ({
    type: scooterAction.FETCH_SCOOTER_DATA,
    payload: { name: name, method: method, url: url, postData: postData, loading: loading },
  }),

  addAccessoryToCart: (id, color) => ({
    //, imgUrl: String, imgUrl: imgUrl
    type: scooterAction.ADD_ACCESSORY_TO_CART,
    payload: { id: id, color: color },
  }),

  removeAccessoryFromCart: (id) => ({
    type: scooterAction.REMOVE_ACCESSORY_FROM_CART,
    payload: id,
  }),

  setVin: (vin) => ({
    type: scooterAction.SET_VIN,
    payload: vin,
  }),

  setQueryLocalSubsidyPayload: (data) => ({
    type: scooterAction.SET_QUERY_LOCAL_SUBSIDY_PAYLOAD,
    payload: data,
  }),

  setColorCode: (code) => ({
    type: scooterAction.SET_COLOR_CODE,
    payload: code,
  }),
}
